<app-widgets-loader
	key="truck-reports"
	[data]="{
		data: data,
		siteId: siteId,
		customerId: customerId,
		isACTuser: user.isACTuser
	}"
	[passAllDataOnce]="true"
></app-widgets-loader>